<template>
  <div class="container">
    <el-menu router
             :default-active="$route.path">
      <el-menu-item index="/notice/announce">
        <img src="./assets/icon-notice.svg"
             alt="">
        <span slot="title"
              style="margin-left:13px">公告中心</span>
      </el-menu-item>
      <el-menu-item index="/notice/guide">
        <img src="./assets/icon-guide.svg"
             alt="">
        <span slot="title"
              style="margin-left:13px">合规指南</span>
      </el-menu-item>
    </el-menu>
    <div class="document-container">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 12px 0 0 12px;
  border-radius: 18px;
  width: 1200px;
  margin: 24px 0;
  display: flex;
  // height: 1700px;
  .document-container {
    // flex: 1;
    min-height: 800px;
    padding-bottom: 48px;
    width: 876px;
    // height: 100vh;
    margin-left: 48px;
  }
}
.el-menu {
  border: none;
  width: 180px;
  .el-menu-item {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
    height: 46px;
    line-height: 46px;
    border-radius: 12px;
    min-width: 180px !important;
    padding-left: 46px;
    margin-bottom: 1px;
  }

  /deep/ .el-menu-item:hover {
    background-color: #f5f5f7 !important;
  }
  /deep/ .el-menu-item.is-active {
    font-family: PingFangSC-Semibold;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 231, 95, 1) 0%,
      rgba(255, 209, 0, 1) 100%
    );
  }
}
</style>
